import IDialogProps from "@/interfaces/Props/Dialog/IDialogProps";
import { createContext, ReactNode, useState } from "react";

interface AlertDialogContextType {
    dialogState: IDialogProps ;
    showDialog: (
      type: IDialogProps["type"],
      title: string,
      message: JSX.Element | string,
      onConfirm?: () => void,
      onCancel?: () => void
    ) => void;
    dismissDialog: () => void;
}

// 建立 Context，初始值為 undefined
export const AlertDialogContext = createContext<AlertDialogContextType | undefined>(undefined);

// **Context Provider**
export const AlertDialogProvider = ({ children }: { children: ReactNode }) => {

    const [dialogState, setDialogState] = useState<IDialogProps>({
      isOpen: false,
      type: "normal",
      title: "",
      message: "",
    });
  
    const showDialog = (
      type: IDialogProps["type"],
      title: string,
      message: JSX.Element | string,
      onConfirm?: () => void,
      onCancel?: () => void
    ) => {
      setDialogState({ isOpen: true, type, title, message, onConfirm, onCancel });
    };
  
    const dismissDialog = () => {
      // 確保 onCancel 被調用（如果有的話）
      if (dialogState.onCancel) {
        dialogState.onCancel();
      }
      setDialogState((prev) => ({ ...prev, isOpen: false }));
    };
  
    return (
      <AlertDialogContext.Provider value={{ dialogState, showDialog, dismissDialog }}>
        {children}
      </AlertDialogContext.Provider>
    );
};